import { makeObservable, observable } from "mobx";
import { MotivoAndamento } from "../modelo/MotivoAndamento";
import Store from "./Store";

class MotivoAndamentoLegadoStore extends Store {
    motivosAndamento: MotivoAndamento[] = [];

    constructor() {
        super();
        makeObservable(this, {
            motivosAndamento: observable
        });
    }
}

export default new MotivoAndamentoLegadoStore();